<sync-header-links></sync-header-links>

<div class="container-fluid container-fluid-wrap-link">
    <div *ngIf="openState == 0" class="header-title">
        <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
    </div>

    <sync-link-file-list *ngIf="openState == 1"></sync-link-file-list>

    <sync-link-consume-password
        *ngIf="openState == 2"
        [errcode]="errcode"
        (password)="onPassword($event)"
    ></sync-link-consume-password>

    <sync-link-error
        *ngIf="openState == 3"
        [errcode]="errcode"
        (linkkey)="onLinkKey($event)"
    ></sync-link-error>

    <div class="link-upsell">
        <span class="hidden-xs" *ngIf="isBusiness == 0"
            >Share your own files absolutely free with
            <a
                href="https://www.sync.com/?_m=h73"
                target="_blank"
                class="syncblue showhand"
                >Sync.com</a
            ></span
        >
        <a
            (click)="showReportDialog()"
            class="pull-right showhand"
            [ngClass]="isWhiteLabel ? 'syncblue-custom' : 'syncblue'"
            >Report link</a
        >
    </div>
</div>
